"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInBrowser = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var isInBrowser = function isInBrowser() {
  return typeof window !== 'undefined' && (0, _get2.default)(window, 'navigator.product') !== 'ReactNative';
};
exports.isInBrowser = isInBrowser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJpc0luQnJvd3NlciIsIndpbmRvdyJdLCJzb3VyY2VzIjpbIi4uL3NyYy91dGlscy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgXyBmcm9tICdsb2Rhc2gnO1xuXG5leHBvcnQgY29uc3QgaXNJbkJyb3dzZXIgPSAoKSA9PlxuICB0eXBlb2Ygd2luZG93ICE9PSAndW5kZWZpbmVkJyAmJlxuICBfLmdldCh3aW5kb3csICduYXZpZ2F0b3IucHJvZHVjdCcpICE9PSAnUmVhY3ROYXRpdmUnO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUVPLElBQU1BLFdBQVcsR0FBRyxTQUFkQSxXQUFXO0VBQUEsT0FDdEIsT0FBT0MsTUFBTSxLQUFLLFdBQVcsSUFDN0IsbUJBQU1BLE1BQU0sRUFBRSxtQkFBbUIsQ0FBQyxLQUFLLGFBQWE7QUFBQTtBQUFDIn0=